export default __webpack_public_path__ + "static/media/gallery_08.d726d1cf.jpg";